React = require 'react'
{ PropTypes } = React
SelectThing = require '../components/SelectThing'

SelectSchool = React.createClass
	displayName: 'SelectSchool'
	propTypes:
		disabled: PropTypes.bool
		feedback: PropTypes.object
		fetchClassroomsBySchool: PropTypes.func
		isFetching: PropTypes.bool
		reduxFormProps: PropTypes.object
		schools: PropTypes.array
		selectedDistrictId: PropTypes.number
		selectedSchoolId: PropTypes.number
		# If `selectSchool` isn't supplied, SelectThing will attempt to use `reduxFormProps.onChange()`
		selectSchool: PropTypes.func
		# If this component should be responsible for fetching classrooms, set `shouldFetchClassrooms` to true.
		# Defaults to false.
		shouldFetchClassrooms: PropTypes.bool

	componentWillMount: ->
		if @props.shouldFetchClassrooms && @props.selectedSchoolId
			@props.fetchClassroomsBySchool(@props.selectedSchoolId)

	componentWillReceiveProps: (newProps) ->
		if newProps.shouldFetchClassrooms && newProps.selectedSchoolId && (newProps.selectedSchoolId != @props.selectedSchoolId)
			@props.fetchClassroomsBySchool(newProps.selectedSchoolId)

	filterSchoolsByDistrict: ->
		@props.schools.filter (school) => school.district_id == @props.selectedDistrictId

	isDisabled: ->
		# If @props.disabled is specified, use that.
		# Otherwise, disable unless either:
		# A) a school id has been passed in via `reduxFormProps`
		# B) a district has been selected
		if @props.disabled then @props.disabled else !@props.reduxFormProps?.value && !@props.selectedDistrictId?

	render: ->
		React.createElement(SelectThing, { \
			"disabled": ( @isDisabled() ),  \
			"feedback": ( @props.feedback ),  \
			"isFetching": ( @props.isFetching ),  \
			"nameField": 'name',  \
			"reduxFormProps": ( @props.reduxFormProps ),  \
			"selectedThingId": ( @props.selectedSchoolId ),  \
			"selectThing": ( @props.selectSchool ),  \
			"thingName": 'school',  \
			"things": ( @filterSchoolsByDistrict() )
		})

module.exports = SelectSchool



// WEBPACK FOOTER //
// ./~/cjsx-loader!./frontend/a2i/js/components/SelectSchool.cjsx